import {
  DateFilter,
  Filter,
  NumberFilter,
  TaxonomyFilter,
  TextFilter,
} from "./types";

export const clearFilterValues: { [key: string]: Partial<Filter> } = {
  taxonomy: {
    value: [],
  } as Partial<TaxonomyFilter>,
  text: {
    value: "",
  } as Partial<TextFilter>,
  number: {
    number1: null,
    number2: null,
    includeNumber1: false,
    includeNumber2: false,
    operator: "gt",
  } as Partial<NumberFilter>,
  date: {
    date1: null,
    date2: null,
    operator: "isAfter",
  } as Partial<DateFilter>,
};
